import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { ViewTooltip } from '../Tooltips/ViewTooltip';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';

export class ViewCard extends ContentCard {

  public render() {
    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor tooltipContent={this.renderTooltipContent} width={DetailsTooltipStyles.Width} onShowTooltip={this.handleShowTooltip}
          title={Messages.viewTooltipTitle()}>
          <Thumbnail navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
                    defaultImageUrl={imgPath('spaces_card_view.svg')}
                    thumbnailImageUrl={this.props.content.thumbnailUrl}
                    hoveredOrSelected={this.props.hoveredOrSelected} />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span data-tb-test-id="view-name" className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          <span>
            <FavoriteToggle canHaveKeyboardFocus={true}
                            isFavorite={this.props.content.favorite}
                            onAddFavorite={() => this.props.addContentFavorite(this.props.content.id, 'view')}
                            onRemoveFavorite={() => this.props.removeContentFavorite(this.props.content.id, this.props.content.id, 'view', this.props.content.name)}/>
          </span>
          { this.renderActionsMenu() }
        </div>
      </div>
    );

  }

  private renderTooltipContent = () => {
    return <ViewTooltip content={this.props.content}
                        urls={this.props.urls} />;
  }
}
